import Presence from './Presence';

export default class PresenceChange {
	previous: Presence | null;

	current: Presence | null;

	constructor(previous: Presence | null, current: Presence | null) {
		this.previous = previous;
		this.current = current;
	}
}
